export const VerifyTableHelpers = {
    data() {
        return {
            tableColumns: [{
                title: this.$t('Solicitud'),
                type: 'custom-html',
                key: 'code',
                modifier: (value, row) => {
                    if (row?.status?.id == 145 || row?.status?.id == 142) {
                        return `<a href="/accreditations/applications/${row.id}" target="_blank">${value || ''}</a>`;
                    } else {
                        return value;
                    }
                }
            },
            {
                title: this.$t('Tipo solicitud'),
                type: 'custom-html',
                key: 'accreditation_activity',
                modifier: (value) => {
                    return value.application_name;
                }
            },
            {
                title: this.$t('Tipo acreditación'),
                type: 'custom-html',
                key: 'accreditation_type',
                modifier: (value) => {
                    return value.name;
                }
            },
            {
                title: 'OEC',
                type: 'custom-html',
                key: 'organization',
                modifier: (value) => {
                    return value.business_name;
                }
            },

            {
                title: this.$t('Fecha creación'),
                type: 'custom-html',
                key: 'created_at',
                modifier: (value) => {
                    if (value) {
                        return moment(value).format("YYYY-MM-DD");
                    }
                }
            },

            {
                title: 'Estado',
                type: 'custom-html',
                key: 'status',
                isVisible: true,
                modifier: (value) => {
                    // let val = value.code;
                    // if (val == "104") {
                    //     return value.name;
                    // }
                    // if (val == "105") {
                    //     return value.name;;
                    // }
                    // if (val == "105") {
                    //     return value.name;;
                    // }
                    return value.name
                }
            },
            {
                title: 'Días Disponibles',
                type: 'custom-html',
                key: 'accreditation_time',
                modifier: (value) => {
                    let tmp;
                    if (value) {
                        if (value.remaining_days > 1) {
                            tmp = `<span class="badge badge-sm badge-pill badge-success">${value.remaining_days}</span>`;
                        }
                        if (value.remaining_days == 1) {
                            tmp = `<span class="badge badge-sm badge-pill badge-warning">${value.remaining_days}</span>`;
                        }
                        if (value.remaining_days == 0) {
                            tmp = `<span class="badge badge-sm badge-pill badge-danger">${value.remaining_days}</span>`;
                        }
                    }
                    return tmp;
                }
            },
            {
                title: 'Corrección',
                type: 'custom-html',
                key: 'accept_acusse_receipt',
                isVisible: true,
                modifier: (value) => {
                    // return value;
                    if (value == 0) {
                        return 'No';
                    } else {
                        return `<span class="badge badge-sm badge-pill badge-danger">Corregido por el OEC</span>`;
                    }
                }
            },
            ],
            actionObj: {
                title: this.$t('action'),
                type: 'action',
            }
        }
    },
}